import { AT } from '../../../actions/actionTypes';
import {
  doAction,
  getStateFull,
  doEmptyAction,
} from '../../../core/redux/store';
import { initPL, State, SetModePL, SetItemsPL } from './model';
import {
  msgAssignSuccess,
  msgAssignError,
  msgUnassignError,
  msgUnassignSuccess,
  getMode,
} from './utils';
import { Modals, Panels } from '../model';
import { setRightPanel, setModal } from '../actions';
import * as Devices from '../../devices';
import * as MyKeysApiDevices from '../../../core/apis/mykeys/devices';
import * as MyKeysApiOrders from '../../../core/apis/mykeys/orders';
import * as MyKeysApiDTypes from '../../../core/apis/mykeys/devicetypes';
import * as MyKeysApiLogin from '../../../core/apis/mykeys/login';
import { ErrorDataResponse } from '../../../core/apis/mykeys/exceptions';
import {
  Groups,
  FeedbackAddPL,
  UserInfo,
  CustomerInfo,
  SelectMode,
} from '../../../models';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import { MyKeysPromise } from '../../../interfaces';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const getState = (): State => getStateFull().dialogState.readrightState;

export const openDialog = () => setRightPanel(Panels.DEVICE_READRIGHTS);
export const openAssignDialog = () => setModal(Modals.DEVICE_READRIGHTS_ASSIGN);

export const initDialog = (groupedBy = Groups.DEVICES, keys: string[] = []) => {
  Logger.info(['initDialog', keys, groupedBy], LogArea.Redux);
  const mode = getMode(groupedBy, keys);
  const payload = { groupedBy, mode, keys };
  doAction<initPL>(AT.DIALOG_READRIGHTS_INIT, payload);
  openDialog();
};

export const setConfirmed = (isConfirmed: boolean) => {
  Logger.info(['setConfirmed', isConfirmed], LogArea.Redux);
  const payload = isConfirmed;
  doAction<boolean>(AT.DIALOG_READRIGHTS_SETCONFIRMED, payload);
}

export const setMode = (groupedBy = Groups.DEVICES, mode: SelectMode) => {
  Logger.info(['setMode', mode], LogArea.Redux);
  const payload = { groupedBy, mode };
  doAction<SetModePL>(AT.DIALOG_READRIGHTS_SETMODE, payload);
};

export const setItems = (keys: string[] = []) => {
  Logger.info(['setItems', keys], LogArea.Redux);
  const payload = { keys };
  doAction<SetItemsPL>(AT.DIALOG_READRIGHTS_SETITEMS, payload);
};

export const updateAssignee = (userInfo: UserInfo) => {
  doAction<UserInfo>(AT.DIALOG_READRIGHTS_UPDATE_ASSIGNEE, userInfo);
}

const assignReadRights = (keys: string[], customer: CustomerInfo) => {
  const state: State = getState();
  Logger.info(['assignReadRights', keys, customer], LogArea.Redux);

  let promise: MyKeysPromise<boolean> | undefined;

  switch (state.groupedBy) {
    case Groups.ORDERS:
      promise = MyKeysApiOrders.assingReadRights(customer, keys);
      break;
    case Groups.DEVICETYPES:
      promise = MyKeysApiDTypes.assingReadRights(customer, keys);
      break;
    case Groups.DEVICES:
      const dKeys = state.mode === SelectMode.All ? [] : keys;
      promise = MyKeysApiDevices.assingReadRights(
        Devices.parseKeys(dKeys), [],
        customer
      );
      break;
    default:
      break;
  }

  if (!promise) return;

  promise
    .then(MyKeysPromiseMap)
    .then((/* data: boolean */) => {
      const payload = { content: [msgAssignSuccess] };
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_SUCCESS, payload);
      doEmptyAction(AT.DIALOG_READRIGHTS_ASSIGN_SUCCESS);
      setRightPanel('');
    })
    .catch((/* err: ErrorDataResponse */) => {
      const payload = { content: [msgAssignError] };
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, payload);
      doEmptyAction(AT.DIALOG_READRIGHTS_ASSIGN_ERROR);
    });

  doEmptyAction(AT.DIALOG_READRIGHTS_ASSIGN_FETCH);
};

export const assign = () => {
  const state: State = getState();
  const { keys } = state;
  const { customer } = state.addressee;
  assignReadRights(keys, customer);
};

export const createAndAssign = () => {
  const state: State = getState();
  const { keys } = state;
  const { email } = state.addressee;

  MyKeysApiLogin.createUser(email)
    .then(MyKeysPromiseMap)
    .then((data: UserInfo) => assignReadRights(keys, data.customer))
    .catch((err: ErrorDataResponse) => {
      //if (Exceptions.UserExists(err)) getCustomerOfAUser(email);
      const payload = { content: [msgAssignError] };
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, payload);
    });

  doEmptyAction(AT.DIALOG_READRIGHTS_ASSIGN_FETCH);
};

export const removeReadRights = (keys: string[]) => {
  Logger.info(['removeReadRights', keys], LogArea.Redux);
  const state = getState();

  let promise: MyKeysPromise<boolean> | undefined;
  switch (state.groupedBy) {
    case Groups.ORDERS:
      promise = MyKeysApiOrders.removeReadRights(keys);
      break;
    case Groups.DEVICETYPES:
      promise = MyKeysApiDTypes.removeReadRights(keys);
      break;
    case Groups.DEVICES:
      const dKeys = state.mode === SelectMode.All ? [] : keys;
      promise = MyKeysApiDevices.removeReadRights(Devices.parseKeys(dKeys), []);
      break;
    default:
      break;
  }
  if (!promise) return;

  promise
    .then(MyKeysPromiseMap)
    .then((/* data: boolean */) => {
      const payload = { content: [msgUnassignSuccess] };
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_SUCCESS, payload);
      doEmptyAction(AT.DIALOG_READRIGHTS_REMOVE_SUCCESS);
      setRightPanel('');
    })
    .catch((/* err: ErrorDataResponse */) => {
      const payload = { content: [msgUnassignError] };
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, payload);
      doEmptyAction(AT.DIALOG_READRIGHTS_REMOVE_ERROR);
    });

  doEmptyAction(AT.DIALOG_READRIGHTS_REMOVE_FETCH);
};
